module.exports = __webpack_public_path__ + "img/measurement_info_back_band_right.e0946660.jpg";